import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      DAYS_LEFT: (days: string) => `${days} igjen`,
      YOU_HAVE_WON: "Du har vunnet!",
      COMPETITION_HAS_ENDED: "Konkurransen avsluttet..",
    },
    se: {
      DAYS_LEFT: (days: string) => `${days} kvar`,
      YOU_HAVE_WON: "Du har vunnit!",
      COMPETITION_HAS_ENDED: "Tävligen slut...",
    },
    dk: {
      DAYS_LEFT: (days: string) => `${days} tilbage`,
      YOU_HAVE_WON: "Du har vundet!",
      COMPETITION_HAS_ENDED: "Konkurrence slut…",
    },
  } as const
)[language];
